module.exports = __webpack_public_path__ + "static/img/nav_bg_fixed.dcaa6613.png";